/* eslint-disable import/no-cycle */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable array-callback-return */
import { toast } from "react-toastify";
import client from "../apollo/apolloClient";
import API from "../axios";
import ApolloConversations from "../apollo/conversations";
import CONSTANTS from "../const/constants";

export const getContacts = async ({
  channelId,
  companyId,
  selectedSpacesIds,
  userId,
}, isAdminOfIds = []) => {
  try {
    let graphQueryFilters = { channelId, companyId };
    if (userId && isAdminOfIds?.length > 0) {
      graphQueryFilters.agentIdIn = isAdminOfIds;
    }

    const {
      data: { clients: fetchedConversations },
    } = await client.query({
      query:
        ApolloConversations.GET_ALL_CONVERSATION_COMPACTED(graphQueryFilters),
      variables: graphQueryFilters,
    });

    return fetchedConversations;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getContactsByKeyword = async ({
  companyId,
  keyword,
  channelId,
  userId,
}, isAdminOfIds = []) => {
  try {
    let graphQueryFilters = { companyId, keyword, channelId };
    if (userId && isAdminOfIds?.length > 0) {
      graphQueryFilters.agentIdIn = isAdminOfIds;
    }
    console.log("getContactsByKeyword=======>", companyId, keyword, channelId, userId);

    const {
      data: { clients: fetchedConversations },
    } = await client.query({
      query:
        ApolloConversations.GET_CONVERSATIONS_BY_SEARCHING_KEYWORD(
          graphQueryFilters
        ),
      variables: graphQueryFilters,
    });

    return fetchedConversations;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const importContacts = async (formData, setProgress) => {
  try {
    console.log("importContacts=======>", formData);

    const response = await API.post("/importContacts", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log(response.data.importContacts);
    return response.data.importContacts;
  } catch (error) {
    toast.error("Error importing contacts");
    throw error;
  }
};
